module.exports = __webpack_public_path__ + "static/media/BlackPapiPacify.3327bfe3.jpg";